import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { closeLoginModal, updateUserForm, signup, login } from 'store/actions/user.actions';
import LoginModal from './login-modal';

const mapStateToProps = ({ user }) => ({
  ...user.form,
  isLoginModalOpen: user.isLoginModalOpen,
  registrationOpen: user.registrationOpen,
  error: user.error,
});
const mapDispatchToProps = (dispatch, props) => ({
  signup: () => dispatch(signup(props.intl)),
  login: () => dispatch(login(props.intl)),
  closeLoginModal: () => dispatch(closeLoginModal()),
  updateUserForm: (key, value) => dispatch(updateUserForm(key, value)),
});
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(LoginModal));
